import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import Button from './../../components/button/Button';
import {newDateTime} from './../../utils/Utils';
import BackArrow from './../../assets/img/back-icon.svg';
import styles from './EventListScreen.module.css';
import NavigationBar from './../../components/navigationBar/NavigationBar';
import { injectIntl, FormattedMessage } from 'react-intl';

import Placeholder from './../../assets/img/placeholder1.jpg';

class EventListScreen extends Component {

    constructor(props){
        super(props);
        this.intl = this.props.intl;
        this.navBarRef = React.createRef();
        this.filters = [];
        this.state = {
            filter: 0,
            pageTransitionEnd: false,
            searchInput: "",
            searchAnimation: "hidden",
        }

        window.scrollTo(0, 0);

        this.backTo = this.backTo.bind(this);
        this.addFilters = this.addFilters.bind(this);
        this.animationEnd = this.animationEnd.bind(this);
        this.updateFilter = this.updateFilter.bind(this);
        this.renderCards = this.renderCards.bind(this);
        this.renderFilters = this.renderFilters.bind(this);
        this.goToEventDetails = this.goToEventDetails.bind(this);

        this.addFilters();
    }

    componentDidMount(props){
        window.onscroll = function(){
            let offset = 59;
            if(window.matchMedia("(orientation: landscape)").matches){
                offset = 140;
            }

            if(window.pageYOffset <= offset && this.state.searchAnimation === "open"){
                this.setState({
                    searchAnimation: "close"
                });
            }
            if(window.pageYOffset > offset && this.state.searchAnimation !== "open"){
                this.setState({
                    searchAnimation: "open"
                });
            }
            if(this.navBarRef.current && window.matchMedia("(orientation: landscape)").matches){
                this.navBarRef.current.showHide(window.pageYOffset);
            }
        }.bind(this);
    }

    addFilters() {
        let today = new Date().setHours(0,0,0,0);

        this.filters.push({
            title: this.intl.formatMessage({id: "filterAll"}),
            rule: function(ev){
                return newDateTime(ev.start_date) >= today || today <= newDateTime(ev.end_date);
            }
        });
        this.filters.push({
            title: this.intl.formatMessage({id: "filterToday"}),
            rule: function(ev){
                return today >= newDateTime(ev.start_date) && today <= newDateTime(ev.end_date);
            }
        });
        // this.filters.push({
        //     title: this.intl.formatMessage({id: "filterTomorrow"}),
        //     rule: function(ev){
        //         let day = new Date();
        //         return new Date(ev.start_date) === day.setDate(day.getDate() + 1);
        //     }
        // });
        this.filters.push({
            title: this.intl.formatMessage({id: "filterWeek"}),
            rule: function(ev){
                let day = new Date();
                let restWeekDays = 7 - (day.getDay() || 7 - 1);
                return newDateTime(ev.start_date) >= today && newDateTime(ev.start_date) <= day.setDate(day.getDate() + restWeekDays) ||
                       today >= newDateTime(ev.start_date) && today <= newDateTime(ev.end_date);
            }
        });
        // this.filters.push({
        //     title: this.intl.formatMessage({id: "filterNextWeek"}),
        //     rule: function(ev){
        //         let day = new Date();
        //         let restWeekDays = 6 - day.getDay();
        //         let startWeek = day.getDate() + restWeekDays;
        //         let endWeek = startWeek + 7;
        //         return (new Date(ev.start_date) >= startWeek) && (new Date(ev.start_date) <= endWeek);
        //     }
        // });
        this.filters.push({
            title: this.intl.formatMessage({id: "filterThisMonth"}),
            rule: function(ev){
                let day = new Date();
                return newDateTime(ev.start_date) >= new Date().setHours(0,0,0,0) && newDateTime(ev.start_date).getMonth() === day.getMonth() ||
                       today >= newDateTime(ev.start_date) && today <= newDateTime(ev.end_date);
            }
        });
    }

    goToEventDetails(eventId) {
        this.props.history.push({
            pathname: '/eventDetails/' + eventId,
            state: {
                animation: "slideInRight"
            }
        });
    }

    backTo(){
        this.props.history.push({
            pathname: "/home",
            state: {
                animation: "slideInLeft"
            }
        });
    }

    animationEnd() {
        this.setState({
            pageTransitionEnd: true
        });
    }

    updateFilter(index) {
        window.scrollTo(0,0);
        this.setState({
            filter: index
        });
    }

    renderFilters() {
        let fixed;
        let filters = this.filters.map((filter, i) => {
            let active;
            if(i === this.state.filter){
                active = styles.filterActive;
            }

            return (
                <div key={i} onClick={() => this.updateFilter(i)} className={[styles.filterOption, active].join(' ')}>
                    {filter.title}
                </div>
            );
        });

        if(this.state.searchAnimation === "open"){
            fixed = styles.fixedFilters;
        }

        return (
            <div className={[styles.filtersContainer, fixed].join(' ')}>
                {filters}
            </div>
        );
    }

    renderCards() {
        if(this.props.events){
            let events = this.props.events;
            events = events
                        .sort(function(e1, e2){
                            return new Date(e1.start_date) - new Date(e2.start_date);
                        }).filter(this.filters[this.state.filter].rule);

            if(events.length === 0){
                return (
                    <div className={styles.eventNotFound}>
                        <h4><FormattedMessage id="eventNotFound" /></h4>
                    </div>
                );
            }else{
                return events
                            .sort((a,b) => {return newDateTime(a.start_date) - newDateTime(b.start_date)})
                            .map((event, i) => {
                            let date = newDateTime(event.start_date);
                            date = date.toLocaleDateString(this.intl.locale, {
                                hour12: true,
                                weekday: "short",
                                month: "short",
                                day: "numeric"
                            }).replace('de', '');

                            date = date.charAt(0).toUpperCase() + date.slice(1);

                            let imageUrl = Placeholder;
                            if(event.banner_url !== ""){
                                imageUrl = event.banner_url;
                            }

                            return (
                                <div>
                                    <div className={[styles.cardContainer, this.props.className].join(' ')}
                                        onClick={() => this.goToEventDetails(event.event_name_normalize)}
                                        style={{backgroundImage: "url(" + imageUrl + ")"}} />
                                    <div className={styles.content}>
                                        <span className={["h4Bold", styles.title].join(' ')}>
                                            {event.event_name}
                                        </span>
                                        <p className={styles.eventHour}>{date}</p>
                                    </div>
                                </div>
                            );
                    });
            }
        }
    }

    render() {
        let animation, topBarStyle, containerStyle, fixed = true, searchAnimation = "";
        if(!this.state.pageTransitionEnd && this.props.location.state && this.props.location.state.animation){
            animation = "animated " + this.props.location.state.animation;
        }
        if(this.state.searchAnimation === "open"){
            searchAnimation = "animated slideInDown";
            containerStyle = styles.containerPadding;
            topBarStyle = styles.topBarOpen;
        }
        if(this.state.searchAnimation === "close"){
            searchAnimation = "animated slideOutUp";
            topBarStyle = styles.topBarClose;
        }

        let topBar;
        if(this.state.searchAnimation !== "hidden"){
            topBar = (
                <div className={[styles.topBar, topBarStyle, searchAnimation].join(' ')}>
                    <h4 className={[styles.topTitle, "h4Bold"].join(' ')}>
                        <FormattedMessage id="events" />
                    </h4>
                </div>
            );
        }

        let titleHidden;
        if(this.state.searchAnimation === "open"){
            titleHidden = styles.hidden;
        }

        if(window.matchMedia("(orientation: landscape)").matches){
            fixed = false;
        }else{
            if(this.navBarRef.current){
                this.navBarRef.current.show();
            }
        }

        return (
            <div>
                <ReactSVG onClick={this.backTo} src={BackArrow} className={styles.backButton}/>
                {topBar}
                <NavigationBar history={this.props.history} fixed={fixed} ref={this.navBarRef} active={"events"} />
                <div className={animation} onAnimationEnd={this.animationEnd}>
                    <div className={[styles.cardsContainer, containerStyle].join(' ')}>
                        <h2 className={titleHidden}><FormattedMessage id="events" /></h2>
                        {this.renderFilters()}
                        {this.renderCards()}
                    </div>
                </div>
            </div>
        );
    }

}

export default injectIntl(EventListScreen);